import React, { useEffect, useRef, useState } from "react";
import styles from "./Second.module.css";
import {
  FaRocket,
  FaHandshake,
  FaFutbol,
  FaLandmark,
  FaLightbulb,
  FaBuilding,
  FaBitcoin,
  FaFileContract,
} from "react-icons/fa";

const items = [
  { text: "Startups & Venture", icon: <FaRocket /> },
  { text: "Mergers & Acquisitions", icon: <FaHandshake /> },
  { text: "Sports Law", icon: <FaFutbol /> },
  { text: "Fund Representation", icon: <FaLandmark /> },
  { text: "Intellectual Property", icon: <FaLightbulb /> },
  { text: "Employment", icon: <FaFileContract /> },
  { text: "Commercial Real Estate", icon: <FaBuilding /> },
  { text: "Blockchain", icon: <FaBitcoin /> },
];

function Second() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(1);
  const [transitionEnabled, setTransitionEnabled] = useState(true);

  const sliderRef = useRef(null);
  const autoplayRef = useRef(null);
  const touchStartX = useRef(0);

  const totalItems = items.length;
  const loopedItems = [...items, ...items.slice(0, visibleCount)];

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 1200) setVisibleCount(4);
      else if (width >= 900) setVisibleCount(3);
      else if (width >= 600) setVisibleCount(2);
      else setVisibleCount(1);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    autoplayRef.current = setInterval(() => {
      handleNext();
    }, 3000);
    return () => clearInterval(autoplayRef.current);
  });

  const handleNext = () => {
    setCurrentIndex((prev) => prev + 1);
  };

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + totalItems) % totalItems);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (diff > 50) handleNext();
    else if (diff < -50) handlePrevious();
  };

  useEffect(() => {
    if (currentIndex === totalItems) {
      setTimeout(() => {
        setTransitionEnabled(false);
        setCurrentIndex(0);
      }, 500);
    } else {
      setTransitionEnabled(true);
    }
  }, [currentIndex, totalItems]);

  const getTransform = () => {
    const slideWidth = 250 + 30;
    return `translateX(-${currentIndex * slideWidth}px)`;
  };

  return (
    <div
      className={styles.background}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      id="practice-areas"
    >
      <h1>We've Got You Covered</h1>
      <div className={styles.carouselWrapper}>
        <div className={styles.arrow} onClick={handlePrevious}>
          {"<"}
        </div>
        <div className={styles.sliderContainer}>
          <div
            ref={sliderRef}
            className={styles.slider}
            style={{
              transform: getTransform(),
              transition: transitionEnabled ? "transform 0.5s ease" : "none",
              width: `${loopedItems.length * 280}px`,
            }}
          >
            {loopedItems.map((item, index) => (
              <div className={styles.card} key={index}>
                <div className={styles.icon}>{item.icon}</div>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.arrow} onClick={handleNext}>
          {">"}
        </div>
      </div>
    </div>
  );
}

export default Second;
